import { BoxTool } from './BoxTool'

export class RectTool extends BoxTool {
	constructor() {
		super({
			mode: 'rect',
			name: '矩形工具',
			className: 'rect',
		});
	}

	onRenderCanvas(ctx, drawing) {
		const { param, brushColor, brushWidth } = drawing;
		const [x, y, width, height] = param;
		ctx.save();
		ctx.strokeStyle = brushColor;
		ctx.lineWidth = brushWidth;
		ctx.beginPath();
		ctx.rect(x, y, width, height);
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/RectTool.js